module.exports = __webpack_public_path__ + "img/help.1db466f4.svg";